import { c7 } from "./c7-hook";
import C7Collection from "./c7-collection";
import C7ProductDetails from "./c7-product-details";

export default function C7Init() {
	this.init = () => {
		new C7Collection().init();
		new C7ProductDetails().init();
	};
}